import { ReactElement } from 'react';
import { Dropdown, Grid, Space } from 'antd';
import { Button } from '../button';
import { Icons } from '../icons';
import { AdaptionActionProps } from './types';

export function AdaptionAction({ items, onClick }: AdaptionActionProps): ReactElement {
  const { md } = Grid.useBreakpoint();
  if (md ?? false) {
    return (
      <Space>
        {items.map(item => (
          <Button {...item} key={item.key} onClick={() => onClick(item)} />
        ))}
      </Space>
    );
  }

  const [firstItem, ...restItems] = items;
  const loading = items.some(items => items.loading);
  const dropdownItems = restItems.map(item => ({
    label: item.label,
    key: item.key,
    icon: item.icon != null && <Icons name={item.icon} />,
    disabled: item.disabled,
    onClick: () => onClick(item)
  }));

  return (
    <Dropdown.Button
      icon={loading ? <Icons name='LoadingOutlined' /> : <Icons name='DownOutlined' />}
      menu={{ items: dropdownItems }}
      loading={firstItem.loading}
      disabled={loading}
      onClick={() => onClick(firstItem)}
    >
      { firstItem.icon != null && <Icons name={firstItem.icon} /> }{ firstItem.label }
    </Dropdown.Button>
  );
}
